import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props: { isLoggedIn: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      outerBox: {
        background: 'linear-gradient(to bottom, #FEF0EA, #E0E0E0)',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      },
      containerBox: {
        width: '96%',
        margin: '0 auto',
        padding: '0px 20px 0px 20px',
        [theme.breakpoints.down('xs')]: {
          padding: '0px 0px 0px 0px'
        }
      },
      menuButtonBox: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
          alignItems: 'center',
          display: props.isLoggedIn ? 'flex' : 'none',
          flex: '1 0 64px'
        }
      },
      menuButton: {
        width: '69px',
        height: '33px',
        background: 'transparent',
        border: 'solid 2px #4B4B4B',
        backgroundColor: '#EFEFEF',
        color: '#4B4B4B'
      }
    })
  );

export const useStylesDashboard = makeStyles((theme: MuiTheme) =>
  createStyles({
    dashboardOuterContainer: {
      borderRadius: '32px',
      margin: '30px 0 30px 0',
      [theme.breakpoints.down('sm')]: {
        margin: '0'
      }
    },
    dashboardSideTabs: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    dashboardInnerContainer: {
      width: 'calc(100% - 236px)',
      background: 'transparent',
      minHeight: 'calc(100vh - 125px)',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    logoBox: {
      height: '100px',
      alignItems: 'center',
      justifyContent: 'center'
    },
    infoText: {
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 600,
      textAlign: 'center',
      color: '#999999'
    }
  })
);
